module.exports = __webpack_public_path__ + "img/old3.1f77d162.jpg";